import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { ensurePermissions } from '@/hooks/usePermissions';
import { hasFeature } from '@/lib/utils/features';
import { bootstrapSession } from '@/lib/utils/session';
import { useSessionStore } from '@/store/sessionStore';

export const Route = createFileRoute('/(client)/files')({
  beforeLoad: async () => {
    const user = useSessionStore.getState().user ?? (await bootstrapSession());
    if (
      !hasFeature(user, 'cascade-tracing') ||
      !hasFeature(user, 'tracing-document-management')
    ) {
      throw redirect({ to: '/dashboard' });
    }

    const { files } = await ensurePermissions();
    if (!files.canRead) throw redirect({ to: '/dashboard' });
  },
  component: () => (
    <PageContainer>
      <Outlet />
    </PageContainer>
  ),
});
